import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import * as S3 from "aws-sdk/clients/s3";
import { environment } from "src/environments/environment";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class AwsService {
  token: string;
  path: string = environment.URL_SERVICIOS.replace("/api/v1", "");
  constructor(public http: HttpClient) {
    this.cargarStorage();
  }
  cargarStorage() {
    if (localStorage.getItem("tkn")) {
      this.token = localStorage.getItem("tkn");
    } else {
      this.token = "";
    }
  }

  uploadFileSB(file: any, name: string) {
    const url = `${environment.URL_SERVICIOS}/contributor_documents/pdf_upload_2?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
    
    // ENDPOINT DE ARCHIVOS MAS PEQUEÑOS
    // const url = `${environment.URL_SERVICIOS}/contributor_documents/pdf_upload?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
    // try {
      // const base64File = await this.convertToBase64(file);
      const formData = new FormData();
      formData.append('nombre_documento', name);
      formData.append('contentType', file.type);
      formData.append('document', file);
      const response = this.http.post(url, formData).toPromise();
      return response;
    /* } catch (error) {
      throw error;
    } */
  }

  async uploadFileSBImages(file: any, name: string) {
    const url = `${environment.URL_SERVICIOS}/contributor_documents/pdf_upload?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
    try {
      const base64File = await this.convertToBase64(file);
      const body = {
        nombre_documento: name,
        contentType: file.type,
        document: base64File
      };
      const response = await this.http.post(url, body).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }

  private convertToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64String = (reader.result as string).replace(/^data:[a-zA-Z\/]+;base64,/, '');
        resolve(base64String);
      };
      reader.onerror = (error) => reject(error);
    });
  }

  async uploadFile(file: any, idu: string) {
    const contentType = file.type;
    const bucket = new S3({
      accessKeyId: environment.AWS.accessKeyId,
      secretAccessKey: environment.AWS.secretAccessKey,
      region: environment.AWS.region,
    });
    const params = {
      Bucket: environment.AWS.bucketNomina,
      Key:
        environment.AWS.folder + "documentosEmpleado/" + idu + "/" + file.name,
      Body: file,
      ACL: "public-read",
      ContentType: contentType,
    };
    return bucket.upload(params).promise();
  }

  async uploadFileRemplazo(file: any, idu: string, fileName: string) {
    const contentType = file.type;
    const bucket = new S3({
      accessKeyId: environment.AWS.accessKeyId,
      secretAccessKey: environment.AWS.secretAccessKey,
      region: environment.AWS.region,
    });
    const params = {
      Bucket: environment.AWS.bucketNomina,
      Key:
        environment.AWS.folder + "documentosEmpleado/" + idu + "/" + file.name,
      Body: file,
      ACL: "public-read",
      ContentType: contentType,
    };
    return bucket.upload(params).promise();
  }

  async delteFile(idu: string, nameFile: string) {
    const params = {
      Bucket: "nominabucket",
      Key: `${environment.AWS.folder}documentosEmpleado/${idu}/${nameFile}`,
    };
    const s3 = new S3({
      accessKeyId: environment.AWS.accessKeyId,
      secretAccessKey: environment.AWS.secretAccessKey,
      region: environment.AWS.region,
    });
    s3.deleteObject(params, function (err, data) {
      console.log(data);
      if (err) console.log(err);
      else console.log("borrado"+params.Key);
    });
  }

  async delteRnomina(idu: string) {
    const params = {
      Bucket: "nominabucket",
      Key: `${environment.AWS.folder}documentosEmpleado/${idu}/recibosNomina/`,
    };
    const s3 = new S3({
      accessKeyId: environment.AWS.accessKeyId,
      secretAccessKey: environment.AWS.secretAccessKey,
      region: environment.AWS.region,
    });
    s3.getObject(params, function (err, data) {
      console.log(data);
      if (err) console.log(err);
      else console.log("borrado"+params.Key);
    });
  }

  async uploadFiless(files: any, idu: string) {
    let taresp: any[] = [];

    for await (let prop of files) {
      const contentType = prop.type;
      const params = {
        Bucket: environment.AWS.bucketNomina,
        Key:
          environment.AWS.folder +
          "documentosEmpleado/" +
          idu +
          "/" +
          "recibosNomina/" +
          prop.name,
        Body: prop,
        ACL: "public-read",
        ContentType: contentType,
      };

      try {
        const r = await this.subiralbucket(params);
        let resp = {
          status: true,
          resp: r,
          msg: "Archivo subido correctamente",
        };
        taresp.push(resp);
      } catch (error) {
        console.log(error);
        let resp = {
          status: false,
          resp: error,
          msg: "Fallo al subir archivo",
        };
        taresp.push(resp);
      }
    }
    let loca = "";
    for await (let prop of taresp) {
      loca = loca + "*" + prop.resp.Location;
    }
    taresp.push(loca);
    return taresp;
  }

  async subiralbucket(params) {
    const bucket = new S3({
      accessKeyId: environment.AWS.accessKeyId,
      secretAccessKey: environment.AWS.secretAccessKey,
      region: environment.AWS.region,
    });
    return bucket.upload(params).promise();
  }

  async CreatePFcustomer(regUsuario: any, idu: string) {
    let data = {
      token: this.token,
      secret_key: environment.SECRET_KEY,
      company_rfc: regUsuario.datosEmpleoAct.rfcemp,
      type: "customer",
      contributor: {
        contributor_type: "PF",
        bank: regUsuario.egrydatban.nombrebanco,
        account_number: regUsuario.egrydatban.ncuentabanco,
        clabe: regUsuario.egrydatban.clabebanco,
        extra1: regUsuario.egrydatban.extra1,
      },
      contributor_address: {
        municipality_id: regUsuario.datosDomicilio.delymun,
        state_id: regUsuario.datosDomicilio.ciudad,
        address_type: "Fiscal",
        street: regUsuario.datosDomicilio.calle,
        external_number: regUsuario.datosDomicilio.nexterior,
        apartment_number: regUsuario.datosDomicilio.ninterior,
        suburb_type: "Urbano",
        suburb: regUsuario.datosDomicilio.colonia,
        postal_code: regUsuario.datosDomicilio.cp,
        address_reference: regUsuario.datosDomicilio.referencia,
      },
      person: {
        fiscal_regime: "PF",
        rfc: regUsuario.datosPersonales.RFC,
        curp: regUsuario.datosPersonales.CURP,
        imss: regUsuario.datosPersonales.imms,
        first_name: regUsuario.datosPersonales.nombre,
        last_name: regUsuario.datosPersonales.apellidop,
        second_last_name: regUsuario.datosPersonales.apellidom,
        gender: regUsuario.datosPersonales.sexo,
        nationality: regUsuario.datosPersonales.nacionalidad,
        birth_country: regUsuario.datosPersonales.pais,
        birthplace: regUsuario.datosPersonales.paisres,
        birthdate: regUsuario.datosPersonales.fechanacimiento,
        martial_status: regUsuario.datosPersonales.casado,
        id_type: regUsuario.datosPersonales.identificacion,
        identification: regUsuario.datosPersonales.nidentificacion,
        phone: regUsuario.datosDomicilio.telparticular,
        mobile: regUsuario.datosDomicilio.telmovil,
        email: regUsuario.datosDomicilio.mailface,
        martial_regime: regUsuario.datosPersonales.regimen,
        minior_dependents: regUsuario.datosPersonales.menores,
        senior_dependents: regUsuario.datosPersonales.mayores,
        housing_type: regUsuario.datosDomicilio.tvivienda,
        extra3: regUsuario.datosCredito.destino
      },
      customer: {
        customer_type: "EMPLEADO",
        status: "AC",
        attached: "",
        user_id: idu,
        seniority: regUsuario.datosLaborales.antiguedad,
        immediate_superior: regUsuario.datosLaborales.jefe,
        salary: regUsuario.egrydatban.sueldomens,
        salary_period: regUsuario.datosLaborales.formaPago,
        company_id: regUsuario.datosEmpleoAct.companyid,
        other_income: regUsuario.egrydatban.oingresos,
        other_income_detail: regUsuario.egrydatban.esoingresos,
        total_income: regUsuario.egrydatban.supertotal,
        house_rent: regUsuario.datosDomicilio.house_rent,
        extra3: regUsuario.datosEmpleoAct.extra3,
        ontime_bonus: regUsuario.egrydatban.bpuntualidad,
        assist_bonus: regUsuario.egrydatban.basistencia,
        food_vouchers: regUsuario.egrydatban.valesdespensa,
        taxes: regUsuario.egrydatban.impuestos,
        imms: regUsuario.egrydatban.retimss,
        savings_found: regUsuario.egrydatban.fahorro,
        savings_found_loand: regUsuario.egrydatban.pfahorro,
        savings_bank: regUsuario.egrydatban.cajaahorro,
        insurance_discount: regUsuario.egrydatban.dseguro,
        extra_expenses: regUsuario.egrydatban.extraordinario,
        infonavit: regUsuario.egrydatban.infonavit,
        child_support: regUsuario.egrydatban.palimentaria,
        public_charge : regUsuario.kyc.public_charge,
        public_charge_det : regUsuario.kyc.public_charge_det,
        relative_charge : regUsuario.kyc.relative_charge,
        relative_charge_det : regUsuario.kyc.relative_charge_det,
        benefit: regUsuario.kyc.benefit,
        benefit_detail: regUsuario.kyc.benefit_detail,
        responsible: regUsuario.kyc.responsible,
        responsible_detail: regUsuario.kyc.responsible_detail,
        job: regUsuario.datosLaborales.puesto
      },
      customer_personal_references: [
        {
          first_name: regUsuario.refPers.nombrenf1,
          last_name: regUsuario.refPers.apellidopnf1,
          second_last_name: regUsuario.refPers.apellidomnf1,
          address: regUsuario.refPers.domnf1,
          phone: regUsuario.refPers.telnf1,
          reference_type: "No familiar",
        },
        {
          first_name: regUsuario.refPers.nombrenf2,
          last_name: regUsuario.refPers.apellidopnf2,
          second_last_name: regUsuario.refPers.apellidomnf2,
          address: regUsuario.refPers.domnf2,
          phone: regUsuario.refPers.telnf2,
          reference_type: "No familiar",
        },
        {
          first_name: regUsuario.refPers.nombrefam,
          last_name: regUsuario.refPers.apellidopfam,
          second_last_name: regUsuario.refPers.apellidomfam,
          address: regUsuario.refPers.domfam,
          phone: regUsuario.refPers.telfam,
          reference_type: "Familiar",
        },
      ],
    };
    const url = `${environment.URL_SERVICIOS}/user_registration?`;
    //  const url = `${environment.URL_SERVICIOS}/api/v1/user_registration?person[fiscal_regime]=PF&person[rfc]=${regUsuario.datosPersonales.RFC}&person[curp]=${regUsuario.datosPersonales.CURP}&person[imss]=${regUsuario.datosPersonales.imss}&person[first_name]=${regUsuario.datosPersonales.nombre}&person[last_name]=${regUsuario.datosPersonales.apellidom}&person[second_last_name]=${regUsuario.datosPersonales.apellidop}&person[gender]=${regUsuario.datosPersonales.sexo}&person[nationality]=${regUsuario.datosPersonales.nacionalidad}&person[birth_country]=${regUsuario.datosPersonales.pais}&person[birthplace]=${regUsuario.datosPersonales.paisres}&person[birthdate]=${regUsuario.datosPersonales.fechanacimiento}&person[martial_status]=${regUsuario.datosPersonales.casado}&person[id_type]=${regUsuario.datosPersonales.identificacion}&person[identification]=${regUsuario.datosPersonales.nidentificacion}&person[phone]=${regUsuario.datosDomicilio.telparticular}&person[mobile]=${regUsuario.datosDomicilio.telmovil}&person[email]=${regUsuario.datosDomicilio.mailface}&person[martial_regime]=${regUsuario.datosPersonales.regimen}&contributor[contributor_type]=PF&contributor[bank]=${regUsuario.egrydatban.nombrebanco}&contributor[account_number]=${regUsuario.egrydatban.ncuentabanco}&contributor[clabe]=${regUsuario.egrydatban.clabebanco}&contributor_address[municipality_id]=${regUsuario.datosDomicilio.delymun}&contributor_address[state_id]=${regUsuario.datosDomicilio.ciudad}&contributor_address[address_type]=Fiscal&contributor_address[street]=${regUsuario.datosDomicilio.calle}&contributor_address[external_number]=${regUsuario.datosDomicilio.nexterior}&contributor_address[apartment_number]=${regUsuario.datosDomicilio.ninterior}&contributor_address[suburb_type]=Urbano&contributor_address[suburb]=${regUsuario.datosDomicilio.colonia}&contributor_address[postal_code]=${regUsuario.datosDomicilio.cp}&contributor_address[address_reference]=${regUsuario.datosDomicilio.referencia}&customer[customer_type]=CF&customer[status]=AC&customer[attached]=https://localhost:3000/contrato&customer[user_id]=ccf9e7f5-89a8-4b82-9470-b9cb1821691d&type=customer&token=${this.token}&secret_key=${environment.SECRET_KEY}&customer[salary]=${regUsuario.egrydatban.sueldomens}&customer[salary_period]=${regUsuario.datosLaborales.formaPago}&customer[company_id]=33829373-c97a-41b0-a512-148eace0e285&company_rfc=AAAA999999A99&customer_personal_reference[first_name]=Omar&customer_personal_reference[last_name]=Gallardo&customer_personal_reference[second_last_name]=Ortiz&customer_personal_reference[address]=Calle tercera numero 25&customer_personal_reference[phone]=6145287986&customer_personal_reference[reference_type]=Familiar&person[minior_dependents]=${regUsuario.datosPersonales.menores}&person[senior_dependents]=${regUsuario.datosPersonales.mayores}&person[housing_type]=${regUsuario.datosDomicilio.tvivienda}&customer[other_income]=${regUsuario.egrydatban.oingresos}&customer[house_rent]=0.00`;
    return this.http.post(url, data).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  async PatchDatosFamiliares(dataref) {
    const url = `${environment.URL_SERVICIOS}/user_update/update_user_info`;
    return this.http.patch(url, dataref).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  async PatchPFcustomer(regUsuario: any) {
    const url = `${environment.URL_SERVICIOS}/user_update/update_user_info`;
    let dataref = {
      token: this.token,
      secret_key: environment.SECRET_KEY,
      person_id: regUsuario.datosEspeciales.person_id,
      customer_pr_id: regUsuario.refPers[0].idcontrolnf1,
      person: {
        imss: regUsuario.datosPersonales.imms
            },
    customer_personal_reference: 
        {
          first_name: regUsuario.refPers[0].nombrenf1,
          last_name: regUsuario.refPers[0].apellidopnf1,
          second_last_name: regUsuario.refPers[0].apellidomnf1,
          address: regUsuario.refPers[0].domnf1,
          phone: regUsuario.refPers[0].telnf1,
          reference_type: "No familiar"
        }
    }
    await (await this.PatchDatosFamiliares(dataref)).toPromise();
    dataref.customer_pr_id = regUsuario.refPers[1].idcontrolnf2;
    dataref.customer_personal_reference.first_name = regUsuario.refPers[1].nombrenf2;
    dataref.customer_personal_reference.last_name = regUsuario.refPers[1].apellidopnf2;
    dataref.customer_personal_reference.second_last_name = regUsuario.refPers[1].apellidomnf2;
    dataref.customer_personal_reference.address = regUsuario.refPers[1].domnf2
    dataref.customer_personal_reference.phone = regUsuario.refPers[1].telnf2
    dataref.customer_personal_reference.reference_type = "No familiar"
    await (await this.PatchDatosFamiliares(dataref)).toPromise();
    dataref.customer_pr_id = regUsuario.refPers[2].idcontrolfam;
    dataref.customer_personal_reference.first_name = regUsuario.refPers[2].nombrefam;
    dataref.customer_personal_reference.last_name = regUsuario.refPers[2].apellidopfam;
    dataref.customer_personal_reference.second_last_name = regUsuario.refPers[2].apellidomfam;
    dataref.customer_personal_reference.address = regUsuario.refPers[2].domfam
    dataref.customer_personal_reference.phone = regUsuario.refPers[2].telfam
    dataref.customer_personal_reference.reference_type = "Familiar"
    await (await this.PatchDatosFamiliares(dataref)).toPromise();
    let data = {
      token: this.token,
      secret_key: environment.SECRET_KEY,
      person_id: regUsuario.datosEspeciales.person_id,
      contributor_id: regUsuario.datosEspeciales.contributor_id,
      customer_id: regUsuario.datosEspeciales.customer_id,
      contributor_address_id: regUsuario.datosEspeciales.contributor_addres_id,
      //customer_pr_id: regUsuario.datosEspeciales.customer_pr_id,
      contributor: {
        bank: regUsuario.egrydatban.nombrebanco,
        account_number: regUsuario.egrydatban.ncuentabanco,
        clabe: regUsuario.egrydatban.clabebanco,
        extra1: regUsuario.egrydatban.extra1,
      },
      contributor_address: {
        municipality_id: regUsuario.datosDomicilio.delymun,
        state_id: regUsuario.datosDomicilio.ciudad,
        street: regUsuario.datosDomicilio.calle,
        external_number: regUsuario.datosDomicilio.nexterior,
        apartment_number: regUsuario.datosDomicilio.ninterior,
        suburb: regUsuario.datosDomicilio.colonia,
        postal_code: regUsuario.datosDomicilio.cp,
        address_reference: regUsuario.datosDomicilio.referencia,
      },
      person: {
        rfc: regUsuario.datosPersonales.RFC,
        curp: regUsuario.datosPersonales.CURP,
        imss: regUsuario.datosPersonales.imms,
        first_name: regUsuario.datosPersonales.nombre,
        last_name: regUsuario.datosPersonales.apellidop,
        second_last_name: regUsuario.datosPersonales.apellidom,
        gender: regUsuario.datosPersonales.sexo,
        nationality: regUsuario.datosPersonales.nacionalidad,
        birth_country: regUsuario.datosPersonales.pais,
        birthplace: regUsuario.datosPersonales.paisres,
        birthdate: regUsuario.datosPersonales.fechanacimiento,
        martial_status: regUsuario.datosPersonales.casado,
        id_type: regUsuario.datosPersonales.identificacion,
        identification: regUsuario.datosPersonales.nidentificacion,
        phone: regUsuario.datosDomicilio.telparticular,
        mobile: regUsuario.datosDomicilio.telmovil,
        email: regUsuario.datosDomicilio.mailface,
        martial_regime: regUsuario.datosPersonales.regimen,
        minior_dependents: regUsuario.datosPersonales.menores,
        senior_dependents: regUsuario.datosPersonales.mayores,
        housing_type: regUsuario.datosDomicilio.tvivienda,
      },
      customer: {
        seniority: regUsuario.datosLaborales.antiguedad,
        immediate_superior: regUsuario.datosLaborales.jefe,
        salary: regUsuario.egrydatban.sueldomens,
        salary_period: regUsuario.datosLaborales.formaPago,
        company_id: regUsuario.datosEmpleoAct.companyid,
        other_income: regUsuario.egrydatban.oingresos,
        total_income: regUsuario.egrydatban.supertotal,
        house_rent: regUsuario.datosDomicilio.house_rent,
        extra3: regUsuario.datosEmpleoAct.extra3,
        ontime_bonus: regUsuario.egrydatban.bpuntualidad,
        assist_bonus: regUsuario.egrydatban.basistencia,
        food_vouchers: regUsuario.egrydatban.valesdespensa,
        taxes: regUsuario.egrydatban.impuestos,
        imms: regUsuario.egrydatban.retimss,
        savings_found: regUsuario.egrydatban.fahorro,
        savings_found_loand: regUsuario.egrydatban.pfahorro,
        savings_bank: regUsuario.egrydatban.cajaahorro,
        insurance_discount: regUsuario.egrydatban.dseguro,
        extra_expenses: regUsuario.egrydatban.extraordinario,
        infonavit: regUsuario.egrydatban.infonavit,
        child_support: regUsuario.egrydatban.palimentaria,
        public_charge : regUsuario.kyc.public_charge,
        public_charge_det : regUsuario.kyc.public_charge_det,
        relative_charge : regUsuario.kyc.relative_charge,
        relative_charge_det : regUsuario.kyc.relative_charge_det,
        benefit: regUsuario.kyc.benefit,
        benefit_detail: regUsuario.kyc.benefit_detail,
        responsible: regUsuario.kyc.responsible,
        responsible_detail: regUsuario.kyc.responsible_detail
      },
      /*customer_personal_references: [
        {
          first_name: regUsuario.refPers.nombrenf1,
          last_name: regUsuario.refPers.apellidopnf1,
          second_last_name: regUsuario.refPers.apellidomnf1,
          address: regUsuario.refPers.domnf1,
          phone: regUsuario.refPers.telnf1,
          reference_type: "No familiar",
        },
        {
          first_name: regUsuario.refPers.nombrenf2,
          last_name: regUsuario.refPers.apellidopnf2,
          second_last_name: regUsuario.refPers.apellidomnf2,
          address: regUsuario.refPers.domnf2,
          phone: regUsuario.refPers.telnf2,
          reference_type: "No familiar",
        },
        {
          first_name: regUsuario.refPers.nombrefam,
          last_name: regUsuario.refPers.apellidopfam,
          second_last_name: regUsuario.refPers.apellidomfam,
          address: regUsuario.refPers.domfam,
          phone: regUsuario.refPers.telfam,
          reference_type: "Familiar",
        },
      ], */
    };
    
    return this.http.patch(url, data).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  async PatchPFcustomerConsulta(person_id: string, fname: string) {
    const url = `${environment.URL_SERVICIOS}/user_update/update_user_info?token=${this.token}&secret_key=${environment.SECRET_KEY}&person_id=${person_id}&person[first_name]=${fname}`;
    return this.http.patch(url, null).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  async patchUrl(idc, idd, urldoc) {
    let params = {
      token: this.token,
      secret_key: environment.SECRET_KEY,
      url: urldoc,
      status: "IN",
    };
    const url = `${environment.URL_SERVICIOS}/contributors/${idc}/contributor_documents/${idd}?`;
    return this.http.patch(url, params).pipe(
      map((resp: any) => {
        console.log(resp)
        return resp;
      })
    );
  }

   patchUrlreemplazo(idc, idd, urldoc) {
    console.log('patchurl')
    let params = {
      token: this.token,
      secret_key: environment.SECRET_KEY,
      url: urldoc,
      status: "IN",
    };
    const url = `${environment.URL_SERVICIOS}/contributors/${idc}/contributor_documents/${idd}?`;
    return this.http.patch(url, params).pipe(
      map((resp: any) => {
        console.log(resp)
        return resp;
      })
    );
  }

  async creauserprueba() {
    const url = "https://run.mocky.io/v3/83b3108b-d56f-4473-be80-546464d10cae";
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  async getDocuments(idu: string) {
    const url = `${environment.URL_SERVICIOS}/contributors/${idu}/contributor_documents?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getUserDocuments(idu: string) {
    const url = `${environment.URL_SERVICIOS}/contributors/${idu}/contributor_documents?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }
  
  getCompanyByRfc(rfc) {
    let params = {
      token: this.token,
      secret_key: environment.SECRET_KEY,
      'rfc': rfc
    };
    const url = `${environment.URL_SERVICIOS}/get_issuing_contributor_by_rfc`;
    return this.http.get(url, {params}).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getDocuments2(idu: string) {
    // const url = `${this.path}/contributors/${idu}/contributor_documents?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
    const url = `${this.path}/contributor_documents?id=${idu}`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  async getDocuments2async(idu: string) {
    // const url = `${this.path}/contributors/${idu}/contributor_documents?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
    const url = `${this.path}/contributor_documents?id=${idu}`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getCountries() {
    const url = `${environment.URL_SERVICIOS}/countries?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        return this.crearArregloStates(resp['data']);
      })
    );
  }

  getCountriesD() {
    const url = `${environment.URL_SERVICIOS}/countries?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        let countries = [];
        resp.data.forEach(element => {
          countries.push(element.attributes)
        });
        return countries;
      })
    );
  }

  getStatesId(id) {
    const url = `${environment.URL_SERVICIOS}/countries/${id}/states?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        return this.crearArregloStates(resp);
      })
    );
  }

  getStates() {
    const url = `${environment.URL_SERVICIOS}/countries/83826a4b-af0e-4bdf-b7b8-0b123abe79b1/states?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        return this.crearArregloStates(resp);
      })
    );
  }

  getMunicipios(idm) {
    const url = `${environment.URL_SERVICIOS}/states/${idm}/municipalities?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        return this.crearArregloStates(resp);
      })
    );
  }

  getColoniasxcp(cp) {
    const url = `${environment.URL_SERVICIOS}/postal_codes/pc/${cp}?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

    return this.http.get(url).pipe(
      map((resp: any) => {
        return this.crearArregloStates(resp);
      })
    );
  }

  crearArregloStates(contribuObj: any) {
    const rr: any[] = [];
    const resul: any[] = [];
    if (contribuObj === null) {
      return [];
    }
    Object.keys(contribuObj).forEach((key) => {
      const rol: any = contribuObj[key];
      rr.push(rol);
    });
    // tslint:disable-next-line: forin
    for (const prop in rr[0]) {
      resul.push(rr[0][prop].attributes);
    }

    return resul;
  }

  pruebacopa() {
    let headers = new HttpHeaders({
      Authorization: "743CEB35-0992-E14E-B0180BAB439ED2A7",
    });
    let options = { headers: headers };
    let body = {
      uuid: "5AB0CE61-FE49-463A-AD1F-DDF02FD9E0DB",
      importe: 141725.63,
    };
    const url = `https://link.copachisa.com/link2/_ws/pagos.cfc?method=actualizaPago`;
    return this.http.post(url, body, options).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  async registroPagos(data) {
    let taresp: any[] = [];
    console.log(data);
    for await (let prop of data) {
      try {
        const r = "correcto";
        let resp = {
          status: true,
          resp: r,
          cc: prop.CLAVE_CREDITO,
          msg: "Pago registrado",
        };
        taresp.push(resp);
      } catch (error) {
        console.log(error);
        let resp = {
          status: false,
          resp: error,
          msg: "Error en el pago",
        };
        taresp.push(resp);
      }
    }
    return taresp;
  }

  getCompanyByUser(uid: string) {
    const url = `${environment.URL_SERVICIOS}/reports/user_id/${uid}/user_company?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  crearArregloList(contribuObj: any) {
    const rr: any[] = [];
    const resul: any[] = [];
    if (contribuObj === null) {
      return [];
    }
    Object.keys(contribuObj).forEach((key) => {
      const rol: any = contribuObj[key];
      rr.push(rol);
    });
    // tslint:disable-next-line: forin
    for (const prop in rr[0]) {
      resul.push([rr[0][prop].attributes.value, rr[0][prop].attributes.key]);
    }
    return resul;
  }

  getUserGender() {
    const url = `${environment.URL_SERVICIOS}/lists/domain/PERSON_GENDER?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getKeyAlsuper() {
    const url = `${environment.URL_SERVICIOS}/lists/domain/ALSUPER?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getPersonBank() {
    const url = `${environment.URL_SERVICIOS}/lists/domain/PERSON_BANK?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getCompanyes() {
    const url = `${environment.URL_SERVICIOS}/reports/get_company?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getInfoRegEmp(idu: string) {
    /* const url = `${environment.URL_SERVICIOS}/reports/user_id/${idu}/get_user_registration?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    ); */
  }

  getInfoRefPers(idu: string) {
    const url = `${environment.URL_SERVICIOS}/reports/user_id/${idu}/get_customer_pr?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getContributorDocuments(idc) {
    const url = `${environment.URL_SERVICIOS}/contributors/${idc}/contributor_documents?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getInfoEmpNss(nss: string) {
    const url = `${environment.URL_SERVICIOS}/listado_alsupers/get_empleado_by_nss/${nss}?secret_key=${environment.SECRET_KEY}&token=${this.token}`;
    return this.http.get(url).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }
}
